import React from "react";
import Headline from "~assets/js/components/Typography/Headline";
import i18next from "i18next";

export const FranchiseSection = () => {
    return (
        <div className="franchise-franchise-section">
            <p className="franchise-franchise-section__teaser">
                {i18next.t("franchise.franchiseSection.teaser")}
            </p>
            <Headline
                size={1}
                className="franchise-franchise-section__headline"
            >
                {i18next.t("franchise.franchiseSection.heading")}
            </Headline>
            <div className="franchise-franchise-section__cards">
                <div className="franchise-franchise-section__card" id="one">
                    <div className="franchise-franchise-section__card__content">
                        <p className="heading">
                            {i18next.t(
                                "franchise.franchiseSection.cardOne.heading"
                            )}
                        </p>
                        <p className="content">
                            {i18next.t(
                                "franchise.franchiseSection.cardOne.content"
                            )}
                        </p>
                    </div>
                </div>
                <div className="franchise-franchise-section__card" id="two">
                    <div className="franchise-franchise-section__card__content">
                        <p className="heading">
                            {i18next.t(
                                "franchise.franchiseSection.cardTwo.heading"
                            )}
                        </p>
                        <p className="content">
                            {i18next.t(
                                "franchise.franchiseSection.cardTwo.content"
                            )}
                        </p>
                    </div>
                </div>
                <div className="franchise-franchise-section__card" id="three">
                    <div className="franchise-franchise-section__card__content">
                        <p className="heading">
                            {i18next.t(
                                "franchise.franchiseSection.cardThree.heading"
                            )}
                        </p>
                        <p className="content">
                            {i18next.t(
                                "franchise.franchiseSection.cardThree.content"
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* Maybe someday

const FRANCHISE_CARDS = [
    {
        IMAGES: [
            {
                URL: "../../static/images/franchise-card/people.png",
                POSITION_X: "left",
                POSITION_Y: "bottom"
            },
        ],
        BIG_TEXT: "",
        SMALL_TEXT: ""
    }
]

const FranchiseSectionCard = ({card}) => {
    const setImageCss = (image) => {
        return {background: `transparent url(${image.URL}) no-repeat ${image.POSITION_X} ${image.POSITION_Y}`}
    }

    return (
        <div className="franchise-franchise-section__card">
            {!!card.IMAGE && (
                <div className="franchise-franchise-section__card__content"
                     style={card.IMAGES.map(image => setImageCss(image))}>
                </div>
            )}
        </div>
    )
};
*/

export default FranchiseSection;
